import { useState } from 'react';

export default function SearchFilters() {
  const [expanded, setExpanded] = useState(false);
  const [searchType, setSearchType] = useState('uid');
  const [searchValue, setSearchValue] = useState('');

  const handleSearch = () => {
    console.log('搜索:', searchType, searchValue);
  };

  const handleReset = () => {
    setSearchValue('');
  };

  return (
    <div className="bg-white rounded-lg p-5 shadow-sm border border-gray-200">
      <div className="space-y-4">
        {/* 搜索区域 */}
        <div className="flex items-center gap-3">
          <select
            value={searchType}
            onChange={(e) => setSearchType(e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent whitespace-nowrap"
          >
            <option value="uid">UID</option>
            <option value="username">用户名</option>
            <option value="phone">手机号码</option>
            <option value="name">姓名</option>
            <option value="idNumber">证件号码</option>
          </select>
          <input
            type="text"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder={`请输入${searchType === 'uid' ? 'UID' : searchType === 'username' ? '用户名' : searchType === 'phone' ? '手机号码' : searchType === 'name' ? '姓名' : '证件号码'}`}
            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
          />
          <button
            onClick={handleSearch}
            className="px-6 py-2 bg-teal-600 text-white rounded-lg text-sm font-medium hover:bg-teal-700 transition-colors whitespace-nowrap"
          >
            搜索
          </button>
          <button
            onClick={handleReset}
            className="px-6 py-2 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-200 transition-colors whitespace-nowrap"
          >
            重置
          </button>
          <button
            onClick={() => setExpanded(!expanded)}
            className="px-4 py-2 text-teal-600 text-sm font-medium hover:bg-teal-50 rounded-lg transition-colors whitespace-nowrap flex items-center gap-1"
          >
            {expanded ? '收起' : '展开'}
            <i className={`ri-arrow-${expanded ? 'up' : 'down'}-s-line`}></i>
          </button>
        </div>

        {/* 筛选条件 */}
        {expanded && (
          <div className="pt-4 border-t border-gray-200 grid grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">注册方式</label>
              <select className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent">
                <option>全部</option>
                <option>手机号码</option>
                <option>微信授权</option>
                <option>QQ授权</option>
                <option>校园</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">实名状态</label>
              <select className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent">
                <option>全部</option>
                <option>已实名</option>
                <option>未实名</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">账号状态</label>
              <select className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent">
                <option>全部</option>
                <option>正常</option>
                <option>禁用</option>
              </select>
            </div>

            <div className="col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-2">注册时间范围</label>
              <div className="flex items-center gap-2">
                <input
                  type="date"
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                />
                <span className="text-gray-500">至</span>
                <input
                  type="date"
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">租户</label>
              <input
                type="text"
                placeholder="搜索租户"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
              />
            </div>

            <div className="col-span-3">
              <label className="block text-sm font-medium text-gray-700 mb-2">用户标签</label>
              <div className="flex flex-wrap gap-2">
                {['学生', '教职工', '企业员工', 'VIP用户', '新用户'].map((tag) => (
                  <label key={tag} className="flex items-center gap-2 px-3 py-2 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 transition-colors">
                    <input type="checkbox" className="w-4 h-4 text-teal-600 rounded focus:ring-teal-500" />
                    <span className="text-sm text-gray-700">{tag}</span>
                  </label>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
